var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        width: 1000,
        height: 322,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: {
          x: "79",
          y: "65",
          rx: "3",
          ry: "3",
          width: "140",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "445",
          y: "62",
          rx: "3",
          ry: "3",
          width: "505",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "446",
          y: "158",
          rx: "3",
          ry: "3",
          width: "350",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "79",
          y: "18",
          rx: "3",
          ry: "3",
          width: "140",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "444",
          y: "16",
          rx: "3",
          ry: "3",
          width: "535",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "444",
          y: "128",
          rx: "3",
          ry: "3",
          width: "505",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "72",
          y: "127",
          rx: "3",
          ry: "3",
          width: "176",
          height: "12",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "808",
          y: "157",
          rx: "3",
          ry: "3",
          width: "141",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "451",
          y: "186",
          rx: "3",
          ry: "3",
          width: "350",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "806",
          y: "211",
          rx: "3",
          ry: "3",
          width: "141",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "624",
          y: "210",
          rx: "3",
          ry: "3",
          width: "164",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "454",
          y: "210",
          rx: "3",
          ry: "3",
          width: "154",
          height: "11",
        },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "67",
          y: "249",
          rx: "3",
          ry: "3",
          width: "176",
          height: "10",
        },
      }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "464", cy: "262", r: "12" } }),
      _vm._v(" "),
      _c("circle", { attrs: { cx: "465", cy: "300", r: "12" } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }